<template>
    <v-container fluid class="ma-1 pa-2">
        <search-toolbar :title="$t('message.256') + '( advanced)'" :filter-enabled="false"></search-toolbar>
        <v-toolbar flat dense color="transparent">
            <v-combobox class="pa-0" v-model="query" placeholder="Search catalogue using ES syntax">
                <template v-slot:item="{ item }">
                    <v-list-tile-content>
                        <v-list-tile-title v-html="getHistoryText(item)"></v-list-tile-title>
                    </v-list-tile-content>
                </template>
            </v-combobox>
            <v-btn icon @click="clearHistory()" title="Clear All Search Histories"><v-icon>history</v-icon></v-btn>
        </v-toolbar>
        <results-widget ref="results" index="catalogue-advanced" :adaptive="true" :link-to-parts="true"></results-widget>
        <facet-widget></facet-widget>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'CatalogueAdvanced',
  data () {
    return {
      loading: false,
      items: [],
      query: null
    }
  },
  mounted () {
  },
  computed: {
    ...mapGetters(
      'history', {
        search: 'search'
      }),
    searchItems: {
      get () {
        return this.search('advanced')
      }
    }
  },
  methods: {
    ...mapActions(
      'history', {
        clearSearch: 'clearSearch'
      }
    ),
    getHistoryText (item) {
      return `${item.search}&nbsp;${this.$moment(item.timestamp).fromNow()}`
    },
    clearHistory () {
      this.$log.debug(`Clearing search history`)
      this.clearSearch({ key: 'advanced' })
    }
  },
  watch: {
    query (value) {
      this.$log.debug(`Catalogue Advanced query: ${value}`)
      this.$refs.results.searchRaw(value)
    }
  }
}
</script>

<style scoped>

</style>
